const e = {
    min: 0,
    max: 100,
    step: 1,
    value: 0,
    error: !1,
    disabled: !1
  },
  r = {
    min: 0,
    max: 100,
    step: 1,
    value: [0, 100],
    error: !1,
    disabled: !1
  };
export { r as rangeSliderDefaultProps, e as sliderDefaultProps };